/**
 * @generated SignedSource<<bfe597ab003d7d7b72f5e4be04b09b34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersArticleSections$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersArticleSections";
};
export type helpersArticleSections$key = {
  readonly " $data"?: helpersArticleSections$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersArticleSections">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersArticleSections"
};

(node as any).hash = "b9d662224a56c16db2e24f7890446548";

export default node;
